<template>
	<div
		:class="[
			buttonStyle ?? blok?.style,
			buttonHeight ?? blok?.height,
			blok?.rounded || '',

			'button cursor-pointer inline-flex items-center justify-center px-5 '
		]"
	>
		<NuxtLink
			v-if="blok"
			:to="resolveLink(link || blok.button_link) || localePath('/')"
			:class="[
				blok.text_size,
				`rounded-5 transition-all md:text-base text-sm button`
			]"
		>
			{{ blok.button_text }}
			<slot />
		</NuxtLink>
		<NuxtLink
			v-else-if="link"
			:to="resolveLink(link) || localePath('/')"
			:class="[textSize, `transition-all text-base w-full text-center button`]"
		>
			{{ text }}
			<slot />
		</NuxtLink>
		<button
			v-else
			:class="[textSize, `transition-all text-base w-full text-center button`]"
		>
			{{ text }}
		</button>
	</div>
</template>

<script setup lang="ts">
import type { BlokButton } from "~/types/storyblok/storyblok";

interface Props {
	blok?: BlokButton;
	link?: string;
	textSize?: string;
	buttonStyle?: string;
	text?: string;
	buttonHeight?: string;
}

const { blok, link, textSize, buttonStyle, text, buttonHeight } =
	defineProps<Props>();

const localePath = useLocalePath();
const { resolveLink } = useStoryblokLink();
</script>
